import { render, staticRenderFns } from "./file-image.vue?vue&type=template&id=21a8708d&scoped=true"
import script from "./file-image.vue?vue&type=script&lang=ts"
export * from "./file-image.vue?vue&type=script&lang=ts"
import style0 from "./file-image.vue?vue&type=style&index=0&id=21a8708d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8708d",
  null
  
)

export default component.exports